export default __webpack_public_path__ + "static/media/director.f5671d30.jpg";